module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/conscientiousness/7b3965fe656de797491d5cbda928d2e1.png";